import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { roundUp } from "LIB/formatters/number";
import { Icon } from "MODULES/shared/components";

const cmFormat = val => `${roundUp(val * 2.54, 1)}cm`;

export const partDimsText = ({ part }) =>
  `${part.length}" x ${part.width}" x ${part.height}"`;

export const partDimsCMText = ({ part }) =>
  `${cmFormat(part.length)} x ${cmFormat(part.width)} x ${cmFormat(
    part.height
  )}`;

export default function Dimensions({ part, showWarning = false }) {
  const activeExisting = classNames({ "text-highlight": showWarning });
  if (part.height) {
    return (
      <td>
        <span className={activeExisting}>
          {showWarning && (
            <span>
              <Icon name="warning" />
              &nbsp;&nbsp;
            </span>
          )}
          {partDimsText({ part })}
        </span>
        <p className={activeExisting}>{partDimsCMText({ part })}</p>
      </td>
    );
  }

  return <td />;
}

Dimensions.propTypes = {
  part: PropTypes.shape({
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  }),
  showWarning: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Search/Dimensions.jsx